import { useRouter } from 'next/router';
import GS from './GS'; // Gloabal Standard
import US from './US'; // US Starndard

/**
 * @param Description: For US site, also apply the blog Design with its' own data(news' data)
 * @param Author: Kalkin
 * @param Release: 2026/01/20
 * @param PM: Alisha Chen
 * @param Referrence: https://ecoflow.feishu.cn/wiki/BK2ywJHOdiZYi6kFA6ccZVuInCc
 * @param Date 2026/01/09
 */
const NEWS: React.FC = () => {
    const { locale = '' } = useRouter();
    const IS_BLOG_UI_SITES = ['us', 'au'].includes(locale);
    return IS_BLOG_UI_SITES ? <US /> : <GS />;
};

export default NEWS;
